import * as React from 'react';
import { SVGProps, memo } from 'react';

function WarningIconTransparent(props?: SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.80546 4.32157L2.80546 17.2828C2.38285 18.0573 2.39976 18.9972 2.84994 19.756C3.30013 20.5147 4.11694 20.98 4.99921 20.9803H18.9992C19.8815 20.98 20.6983 20.5147 21.1485 19.756C21.5987 18.9972 21.6156 18.0573 21.193 17.2828L14.193 4.32157C13.7546 3.51943 12.9133 3.02051 11.9992 3.02051C11.0851 3.02051 10.2439 3.51943 9.80546 4.32157V4.32157Z"
        stroke="#EB6100"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M12 7.9834V15.0459" stroke="#EB6100" strokeLinecap="round" strokeLinejoin="round" />
      <ellipse
        cx="12"
        cy="17.4834"
        rx="0.125"
        ry="0.125"
        stroke="#EB6100"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <ellipse cx="12.0002" cy="17.4826" rx="0.62125" ry="0.62125" fill="#EB6100" />
    </svg>
  );
}
export default memo(WarningIconTransparent);
